import { atom } from "recoil"

export const rtcAutoplayFailedState = atom({
  key: "rtcAutoplayFailedState",
  default: false
})
